__turbopack_context__.v({
  "className": "inter_9cfe0d90-module__6w3gVG__className",
  "variable": "inter_9cfe0d90-module__6w3gVG__variable",
});
